// Module
var code = "<tr class=offerRow> <td colspan=10 class=text-center> The offer you have searched is no longer available. </td> </tr>";
// Exports
module.exports = code;